













































































import { Component, Prop, Vue } from "vue-property-decorator";
import DateFormat from "@/utility/DateFormat";
import http from "@/axios/http-common";
import moment from "moment";

@Component({
  components: {},
})
export default class RiwayatPrmrj extends Vue {
  @Prop() riwayatPrmrj!: string;
  @Prop() rm!: string;

  cetak() {
    const routeData = http.getAPI() + "/prmrj/pasien/" + this.rm + "/pdf";
    window.open(routeData, "_blank");
  }

  formatTgl(tgl) {
    return DateFormat.formatDate(tgl);
  }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }
}
